import React from 'react';
import { Route } from 'react-router-dom';
import { lazyWithRetry } from '@/routes/utils';

export const Home = lazyWithRetry(() => import('@/pages/home/Home'));

export const homeRoutes = (
  <Route path="/home" element={<Home />} />
);
